export const CRT_FILTER_OPTIONS = {
  curvature: 1.0,
  lineWidth: 1.0,
  lineContrast: 0.3,
  verticalLine: false,
  noise: 0.1,
  noiseSize: 0.2,
  seed: Math.random(),
  vignetting: 0.2,
  vignettingAlpha: 0.4,
  vignettingBlur: 0.8,
  time: 0.5,
  alpha: 0.1
}